var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_270_19",
    "data-name": "Component 270 \\u2013 19",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27205",
    "data-name": "Group 27205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3758",
    "data-name": "Rectangle 3758",
    width: 24,
    height: 24,
    rx: 2,
    fill: "#2c74bd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13627",
    "data-name": "Path 13627",
    d: "M10.838,5.789a8.738,8.738,0,0,1,7.888,4.919,8.785,8.785,0,0,1-15.777,0,8.738,8.738,0,0,1,7.888-4.919m0-1.789A10.578,10.578,0,0,0,1,10.708a10.569,10.569,0,0,0,19.676,0A10.578,10.578,0,0,0,10.838,4Zm0,4.472A2.236,2.236,0,1,1,8.6,10.708a2.237,2.237,0,0,1,2.236-2.236m0-1.789a4.025,4.025,0,1,0,4.025,4.025A4.031,4.031,0,0,0,10.838,6.683Z",
    transform: "translate(1.162 0.792)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.8981b28ae27c0a28c18c64609d67ed38.svg";
export { ForwardRef as ReactComponent };